<form nz-form [formGroup]="approveCorrectionRequestForm">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="ordered-list" nzTheme="outline"></i> Organization Information Comparison
  </div>

  <div class="searchboxAerar p-3">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Field</th>
            <th>Current Organization Information</th>
            <th>Requested Correction Information</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of comparisonFields">
            <td class="comparison-label-cell">{{ field.label }}</td>
            <td>{{ getDisplayValue(field.previousKey) }}</td>
            <td [ngClass]="{ 'table-warning': isFieldChanged(field.previousKey, field.requestedKey) }">
              {{ getDisplayValue(field.requestedKey) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <br>

  <div class="searchboxAerar p-3">
    <fieldset *ngIf="this.approveCorrectionRequestForm.get('isPayment')?.value">
      <legend style="font-size: 18px; color: rgb(0, 0, 0)" class="text-weight">
        Payment Information:
      </legend>

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label class="text-weight">Payment Date</nz-form-label>
          <nz-form-label nzNoColon>{{ this.approveCorrectionRequestForm.get('paymentDate')?.value | date: "dd-MM-YYYY" }}</nz-form-label>
        </div>

        <div class="form-group col-md-8">
          <nz-form-label class="text-weight">Transaction No</nz-form-label>
          <nz-form-label nzNoColon>{{ this.approveCorrectionRequestForm.get('transactionNo')?.value }}</nz-form-label>
        </div>
      </div>

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label class="text-weight">Payment Amount</nz-form-label>
          <nz-form-label nzNoColon>{{ this.approveCorrectionRequestForm.get('paymentAmount')?.value }} Taka</nz-form-label>
        </div>
      </div>

      <br>
    </fieldset>

    <fieldset>
      <legend style="font-size: 18px; font-weight: bold; color: rgb(25, 0, 255)">
        Review Request:
      </legend>
    </fieldset>

    <div class="col-md-12">
      <div class="mb-2 row">
        <div class="col-md-4 col-sm-12 text-right">
          <nz-form-label nzRequired>Decision</nz-form-label>
        </div>
        <div class="col-md-4 col-sm-12">
          <nz-form-item>
            <nz-form-control nzErrorTip="Please select decision !">
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="approvalStatusId"
                nzPlaceHolder="Select Approval Status"
              >
                <nz-option
                  *ngFor="let item of approvalStatusList"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="mb-2 row" *ngIf="this.approveCorrectionRequestForm.get('approvalStatusId')?.value == 2">
        <div class="col-md-4 col-sm-12 text-right">
          <nz-form-label nzRequired>Remarks</nz-form-label>
        </div>
        <div class="col-md-4 col-sm-12">
          <nz-form-item>
            <nz-form-control
              nzHasFeedback
              [nzErrorTip]="remarksErrorTpl"
            >
              <textarea
                nz-input
                type="text"
                formControlName="rejectedRemarks"
                placeholder="Remarks"
              ></textarea>
              <ng-template #remarksErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input remarks !
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>

    <div class="row justify-content-center media-button">
      <div class="col-xs-6 col-sm-4">
        <button *ngIf="!this.isSubmit"
        type="button"
        [disabled]="!approveCorrectionRequestForm.valid"
        class="btn btn-success active btn-lg btn-block cari border-redius"
        nz-popconfirm
        nzPopconfirmTitle="Are you sure to submit the decision? Once submitted, it can not be undone!"
        (nzOnConfirm)="submitApprovalDecision()"><i nz-icon nzType="save" nzTheme="fill"></i> Submit Decision
        </button>
      </div>
    </div>

    <br>
  </div>
</form>
